import angular from "angular";
import { directiveFactory } from "../../angular-core";

interface ILocalScope extends ng.IScope {
    budgetYear: number;
    marketName: string;
    marketVersion: number;
    marketId: number;
}

export class MarketNameUniqueValidationDirective implements ng.IDirective<ILocalScope> {
    static componentName: string = "marketNameUniqueValidation";
    static $inject = ["$http", "$q"];

    require = "ngModel";
    restrict = "A";
    scope = {
        budgetYear: "<",
        marketName: "<",
        marketVersion: "<",
        marketId: "<"
    };

    link = ($scope: ILocalScope, element: JQLite, attrs: ng.IAttributes, ngModel: $TSFixMe) => {
        const propertyBoundToModel = attrs["ngModel"];
        const getPropertyValue = (propertyName: keyof ILocalScope, value: string) =>
            attrs[propertyName] === propertyBoundToModel ? value : $scope[propertyName];

        ngModel.$asyncValidators.marketNameUnique = (v: string, e: string) => {
            return this.$http
                .post("/api/market/unique", {
                    marketName: getPropertyValue("marketName", v ?? e),
                    version: getPropertyValue("marketVersion", v ?? e),
                    budgetYear: getPropertyValue("budgetYear", v ?? e),
                    marketId: getPropertyValue("marketId", v ?? e)
                })
                .then(
                    (response: $TSFixMe) => {
                        if (response.data) {
                            return true;
                        }
                        return this.$q.reject("exists");
                    },
                    () => false
                );
        };

        const scopePropertiesBoundToModel = Object.entries(attrs)
            .filter(([_, value]) => value === propertyBoundToModel)
            .map(([key]) => key);

        const propertiesToWatch = ["marketName", "budgetYear", "marketVersion"].filter(
            p => !scopePropertiesBoundToModel.includes(p)
        );

        propertiesToWatch.forEach(p => $scope.$watch(p, () => ngModel.$validate()));
    };

    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService) {}
}

angular
    .module("topline.directives")
    .directive(
        MarketNameUniqueValidationDirective.componentName,
        directiveFactory(MarketNameUniqueValidationDirective)
    );
